export default __webpack_public_path__ + "static/media/dark-blue-gradient.0feb4119.svg";